module.exports = __webpack_public_path__ + "static/pinkbunnyteether-1e727a6deb7466edd7cdcc4cc4b16525.jpeg";